// JavaScript Document
//components/configuration/disdplay/Sequence.js
import React from 'react';
import Display from './Static';
//import PropTypes from 'prop-types';
//import { makeStyles } from '@material-ui/core/styles';
//import AppBar from '@material-ui/core/AppBar';
//import Typography from '@material-ui/core/Typography';
//import Box from '@material-ui/core/Box';
//import Card from '@material-ui/core/Card';
//import CardActions from '@material-ui/core/CardActions';
//import CardContent from '@material-ui/core/CardContent';
//import Button from '@material-ui/core/Button';
/*
const useStyles = makeStyles((theme) => ({
	udisplay: {
		backgroundColor: 'black',
		padding: 5,
		color: '#ffaa00',
		height: 55,
		boxSizing:'border-box',
		width : 70
	},
}));
*/


export default function Sequence(props) {
  	//const classes = useStyles();
  	const {ids, width, height, pixel_maps, timing, scale, splitVertical, borderSize} = props;
	//const [msgid, setMsgid] = React.useState(0);
	//const [imgpath, setImgpath] = React.useState('/needs/vspeedOnline/sign-data/pixel_messages/');
	//const [size, setSize] = React.useState([30, 18]);
	//const [scaling, setScaling] = React.useState(2);
	const [step, setStep] = React.useState(0);
	const [displayState, setDisplayState] = React.useState('on');
	const [flashing, setFlashing] = React.useState(false);
	//const [img, setImg] = React.useState('/needs/vspeedOnline/sign-data/pixel_messages/0.gif');
	//const [pixels, setPixels] = React.useState('000011100100000011100100010000,000100010100000100010100010000,000100000100000100010101010000,000100000100000100010101010000,000011100100000100010101010000,000000010100000100010101010000,000000010100000100010101010000,000100010100000100010101010000,000011100111110011100011100000,000111100011100100010100010000,000100010100010100010100010000,000100010100010101010110010000,000100010100010101010101010000,000100010100010101010100110000,000100010100010101010100010000,000100010100010101010100010000,000100010100010101010100010000,000111100011100011100100010000,');
	//standard is 30 x 18
	
	React.useEffect(() => {
		//if(id){
		//	setMsgid(id);
		//}
		//if(path){
		//	setImgpath(path);
		//}
		//if(width && height){
		//	setSize([width, height]);
		//	if(msgid === 0 || msgid === '0'){
		//		setPixels(Array(height).fill('0'.repeat(width)).join(','));
		//	}
		//}
		//if(scale){
		//	setScaling(scale);
		//}
		//if(displayState === 'on'){
		//	setIsOn(true);
		//} else if(displayState === 'off'){
		//	setIsOn(false);
		//}
		//if(msgid && imgpath){
		//	setImg(imgpath+msgid+'.gif');
		//}
		//if(pixel_map){
		//	setPixels(pixel_map);
			//console.log("Pixels are");
			//console.log(pixel_map);
		//}
		//if(timing){
		setFlashing(true);
		setStep(0);
		setDisplayState('on');
		//}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [props]);
	
	React.useEffect(() => {
		if(flashing){
			//setIsOn(false);
			setDisplayState('off');
			//console.log('start flash');
			setTimeout(() => {
				setFlashing(false);
				setStep(0);
				setDisplayState('on');
			}, timing.period * 1000 * 2);
			//setTimeout(() => setIsOn(true), timing.off);
		} else {
			setDisplayState('on');
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [flashing]);
	
	React.useEffect(() => {
		if(flashing){
			if(displayState === 'on'){
				setTimeout(() => setDisplayState('off'), timing.on);
			} else {
				setStep((step+1)%pixel_maps.length);
				setTimeout(() => setDisplayState('on'), timing.off);
			}
		} else {
			setDisplayState('on');
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [displayState]);
	
	return (
		<Display 
	  		id={ids[step]} 
			scale={scale} 
			splitVertical={splitVertical} 
			width={width} 
			height={height} 
			displayState={displayState}
			pixel_map={pixel_maps[step]}
			borderSize={borderSize}
		/>
  );
}
